export class FacebookTracking {

    track(event: string, name: string, value: any) {
        // @ts-ignore
        if (window.WlConsentManager) {
            // @ts-ignore
            window.WlConsentManager.hasConsentForCustomVendor('Facebook_Pixel').then(function (consent) {
                // @ts-ignore
                if (consent && typeof fbq === 'function') {
                    // @ts-ignore
                    fbq(event, name, value);
                }
            });
        }
    }
}
